import { render, staticRenderFns } from "./IngredientForCouvertureItem.vue?vue&type=template&id=04689437"
import script from "./IngredientForCouvertureItem.vue?vue&type=script&lang=js"
export * from "./IngredientForCouvertureItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports